import DialogExt from './src/dialogext.vue';

DialogExt.install = function (Vue) {
    Vue.component(DialogExt.name, DialogExt);
};

export default DialogExt;